module.exports = __webpack_public_path__ + "img/6a45efb2a6a52393.6b373af3.png";